import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { DeepReadonly } from "ts-essentials"
import { Button } from "@mui/material"
import useMountEffect from "hooks/mount-effect"
import { Creators as DialogCreators } from "modules/dialog/model"

export default function EmptyDashboard({ openUnifiedSearch }: DeepReadonly<EmptyDashboardProps>) {
  const dispatch = useDispatch()

  useMountEffect(() => {
    openUnifiedSearch()
  })

  // Close the picker on unmount: if this instance briefly rendered during a dashboard switch/redirect
  // and the target turns out to already have an instrument, the dialog would otherwise stay stuck
  // open over the now-populated dashboard — the dialog is global state, not tied to our lifecycle.
  useEffect(() => () => {
    dispatch(DialogCreators.close())
  }, [dispatch])

  return <div className="modules_dashboard-root">
    <div className="dashboard-empty">
      <h4>Please select an instrument first</h4>
      <Button className="dashboard-empty-button" variant="contained" color="primary" onClick={openUnifiedSearch}>Search</Button>
    </div>
  </div>
}

interface EmptyDashboardProps {
  openUnifiedSearch: () => void
}
